export const ThemedLayout = ({ children }) => children;
